import {observer} from 'mobx-react';
import React from 'react';
import {DroppableComponentProps} from '../models';
import {DragDropContextStore} from '../drag-drop-context/DragDropContextStore';
import {DroppableReactContext} from './DroppableReactContext';
import {DroppableStore} from './DroppableStore';

interface DroppableImplProps extends DroppableComponentProps {
  contextStore: DragDropContextStore,
  parent: DroppableStore | null
}

@observer
export class DroppableImpl extends React.Component<DroppableImplProps> {
  readonly store: DroppableStore;

  constructor(props: Readonly<DroppableImplProps>) {
    super(props);
    this.store = new DroppableStore(this);
  }

  componentDidMount() {
    this.store.mount();
  }

  render() {
    const children = this.props.children;
    const childProvided = this.store.droppableChildProvided;
    return (
      <DroppableReactContext.Provider value={this.store}>
        {children(childProvided)}
      </DroppableReactContext.Provider>
    );
  }

  componentWillUnmount() {
    this.store.dispose();
  }
}
